module.exports = __webpack_public_path__ + "static/original-mattress-2-1ab9afad0f938fb9d5b852a2057f0aad.webp";